module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a2e09fa89bbe4b6d9f3364168c3caa94.png";